import ControlGroup from '../../../../components/ControlGroup';
import { MovingGradient } from '../../../../components/MovingGradient';
import { ThemeStyle } from '../../../../utils/const';
import { useStyleContextState } from '../../../styleContext';
import { useListSidebarProvider } from '../../components/ListSidebar/useListSidebarProvider';
import { getRandomBoundary } from './utils';

function ListLoadingPlaceholderSidebarItem() {
	const listSidebarProvider = useListSidebarProvider();
	const { theme } = useStyleContextState();
	const labelWhite = listSidebarProvider !== null && theme !== ThemeStyle.Light;
	const label = (
		<MovingGradient
			height='12px'
			width={getRandomBoundary(35, 145)}
		/>
	);

	return (
		<ControlGroup
			labelWhite={labelWhite}
			label={label}
		>
			<MovingGradient
				height='32px'
				width='100%'
			/>
		</ControlGroup>
	);
}
export { ListLoadingPlaceholderSidebarItem };
